export const QUERY_KEYS = {
  AGENCIES: 'agencies',
  BILLING_CONTACTS: 'billingContacts',
  TOP_CHARTS: 'topChars',
  ONEFLIGHT_CLIENTS: 'oneFlightClients',
  ONEFLIGHT_CLIENT_BRANDS: 'oneFlightClientBrands',
} as const;
